import {translate} from '@/services/translations'
const $gettext = translate.gettext.bind(translate)

/**
 * Message Categories
 */
const DOCUMENTATION = 'DOCUMENTATION'
const GRANT_DECISION = 'GRANT_DECISION'
const REFERRAL = 'REFERRAL'
const OTHER = 'OTHER'

// Use this for dropdown menus
const MESSAGE_CATEGORY_CHOICES = [
  {value: DOCUMENTATION, label: $gettext('Documentation')},
  {value: GRANT_DECISION, label: $gettext('Grant Decision')},
  {value: REFERRAL, label: $gettext('Referral')},
  {value: OTHER, label: $gettext('Other')},
]

const DIGITAL_MESSAGE = 'DIGITAL_MESSAGE'
const DIGITAL_MESSAGE_ENGLISH = 'DIGITAL_MESSAGE_ENGLISH'
const DIGITAL_MESSAGE_SPANISH = 'DIGITAL_MESSAGE_SPANISH'
const PHONE_CALL = 'PHONE_CALL'
const BESPOKE_SMS = 'BESPOKE_SMS'
const PHONE_CALL_INCOMING = 'PHONE_CALL_INCOMING'
const PHONE_CALL_OUTGOING = 'PHONE_CALL_OUTGOING'
const BESPOKE_SMS_INCOMING = 'BESPOKE_SMS_INCOMING'
const BESPOKE_SMS_OUTGOING = 'BESPOKE_SMS_OUTGOING'

const MESSAGE_TYPE_CHOICES = [
  {value: DIGITAL_MESSAGE_ENGLISH, label: 'Digital Message - English'},
  {value: DIGITAL_MESSAGE_SPANISH, label: 'Digital Message - Spanish'},
  {value: PHONE_CALL_INCOMING, label: 'Phone Call - Incoming'},
  {value: PHONE_CALL_OUTGOING, label: 'Phone Call - Outgoing'},
  {value: BESPOKE_SMS_INCOMING, label: 'Bespoke SMS - Incoming'},
  {value: BESPOKE_SMS_OUTGOING, label: 'Bespoke SMS - Outgoing'},
]

const SEND_NOW = "SEND_NOW"
const SCHEDULED = "SCHEDULED"

const MESSAGE_SCHEDULE_CHOICES = [
  {value: SEND_NOW, label: 'Send Now'},
  {value: SCHEDULED, label: 'Scheduled'},
]

const MESSAGE_SENT = "MESSAGE_SENT"
const MESSAGE_SCHEDULED = "MESSAGE_SCHEDULED"

const MESSAGE_STATUS_CHOICES = [
  MESSAGE_SENT,
  MESSAGE_SCHEDULED,
]

export default {
  DOCUMENTATION,
  GRANT_DECISION,
  REFERRAL,
  OTHER,
  MESSAGE_CATEGORY_CHOICES,
  MESSAGE_TYPE_CHOICES,
  DIGITAL_MESSAGE,
  DIGITAL_MESSAGE_ENGLISH,
  DIGITAL_MESSAGE_SPANISH,
  PHONE_CALL,
  PHONE_CALL_INCOMING,
  PHONE_CALL_OUTGOING,
  BESPOKE_SMS,
  BESPOKE_SMS_INCOMING,
  BESPOKE_SMS_OUTGOING,
  SEND_NOW,
  SCHEDULED,
  MESSAGE_SCHEDULE_CHOICES,
  MESSAGE_SENT,
  MESSAGE_SCHEDULED,
  MESSAGE_STATUS_CHOICES,
}
